import React, { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogActions,
  DialogContent,
  Typography,
  IconButton,
  Divider,
  Button,
  Box,
} from '@material-ui/core';
import { Close } from '@material-ui/icons';
import { useDispatch, useSelector } from 'react-redux';

import DuAnForm from '../DuAnForm/DuAnForm';
import { dateFormatter } from '../../../../utils';
import { fileActions, researchProjectActions } from '../../../../actions';

export default function DuAnInsert(props) {
  const dispatch = useDispatch();
  const profileId = useSelector(state => state.profileReducer.profile?.id);

  const [values, setValues] = useState(null);

  const handleSubmit = () => {
    dispatch(fileActions.importPreviewFile(profileId, values?.previewFile[0]))
      .then((response) => dispatch(researchProjectActions.insertResearchProject([{
        ...values,
        profileId,
        link: response,
        start_at: dateFormatter(values.start_at),
        finish_at: dateFormatter(values.finish_at),
      }])));
    setValues(null);
    props.onClose();
  }

  return (
    <Dialog
      fullWidth
      maxWidth='sm'
      open={props.open}
    >
      <DialogTitle style={{ padding: '4px 12px 4px 24px' }}>
        <Box display='flex' justifyContent='space-between' alignItems='center'>
          <Typography variant='h5'>Thêm đề tài dự án</Typography>
          <IconButton onClick={props.onClose}><Close /></IconButton>
        </Box>
      </DialogTitle>
      <Divider />
      <DialogContent>
        <DuAnForm
          id='du-an'
          values={values}
          setValues={setValues}
          handleSubmit={handleSubmit}
        />
      </DialogContent>
      <DialogActions style={{ padding: '8px 24px' }}>
        <Button variant='outlined' onClick={props.onClose}>
          Huỷ
        </Button>
        <Button form='du-an' type='submit' variant='contained' color='secondary'>
          Xác nhận
        </Button>
      </DialogActions>
    </Dialog>
  );
}

